import axios from 'axios';

export default {
    // getToken({commit,rootGetters}){
    //     let devolver = {
    //         'ok' : false
    //     };
    //     let url = rootGetters['config/urlNeo'];
    //     let apikey = rootGetters['config/apikeyNeo'];
    //     let centro = rootGetters['config/centroNeo'];
    //     let data = new FormData();
    //     data.append('Centro',centro);
    //     data.append('APIKey',apikey);
    //     let a =  axios.post(url+'gettoken.php', data)
    //     .then(function(res){
    //         let devolver = {
    //             ok : false
    //         };
    //         console.log(res.data);
    //         let data = res.data;
    //         if (data.result === "OK"){                  
    //             commit('setToken',data.token);
    //             devolver.ok = true;
    //         } else {
    //             devolver.error = data.message
    //         }
    //         return devolver;
    //     })
    //     .catch((error) => {
    //         devolver.error = error
    //         return devolver;
    //     })
    //     return a;

    // },
    // verArticulosNeoTPV({state,commit,rootGetters}, marcaTiempo = null){
    //     let url = rootGetters['config/urlNeo'];
    //     let devolver = {
    //         'ok' : false
    //     };
    //     let data = new FormData();
    //     data.append('token',state.token);
    //     if (marcaTiempo){
    //         data.append('fecha',marcaTiempo);
    //     }
    //     let a =  axios.post(url+'verarticulos.php', data)
    //     .then(function(res){
    //         let devolver = {
    //             ok : false
    //         };
    //         let data = res.data;
    //         console.log("pasa por aqui 2" )
    //         if (data.result === "OK"){
    //             commit('restaurante/setProdBartolome', data.articulos, {root: true});
    //             devolver.ok = true;
    //         } else {
    //             devolver.error = data.message

    //         }
    //         return devolver;
    //     })
    //     .catch((error) => {
    //         devolver.error = error
    //     })
    //     return a;
    // },
    // verComposicion({state,rootGetters},id){
    //     let url = rootGetters['config/urlNeo'];
    //     let devolver = {
    //         'ok' : false
    //     };
    //     let data = new FormData();
    //     data.append('token',state.token);
    //     data.append('articulo',id)
    //     let a =  axios.post(url+'vercomposicion.php', data)
    //     .then(function(){
    //         let devolver = {
    //             ok : false
    //         };
    //         return devolver;
    //     })
    //     .catch((error) => {
    //         devolver.error = error
    //     })
    //     return a;
    // },
    // insertarPedido({state,dispatch,rootGetters},pedido){
    //     /*let url = rootGetters['config/urlNeo'];
    //     let devolver = {
    //         'ok' : false
    //     };*/
        
    //     dispatch('getToken')
    //     .then(() => {
    //         // let productos = pedido.carrito.productos;
    //         let lineas = [];
    //         // productos.forEach((p,i) => {
    //         //     let l_aux = {
    //         //         Linea: i+1,
    //         //         CodArticulo: "01000023", 
    //         //         Cantidad: 2,
    //         //         PrecioUnit: 6.00,
    //         //         PorDto: 10,
    //         //         Observaciones: "Con poca sal", "TipoLinea": 0
    //         //     }
    //         // });
    //         let pedidoNeo = {
    //             NombreCliente : 'Totem: ' + pedido.codigoTotem,
    //             CifCliente : ' - ',
    //             DirCliente : ' - ',
    //             CiudadCliente : ' - ',
    //             ProvinciaCliente: ' - ',
    //             PaisCliente : ' - ',
    //             CPCliente : ' - ',
    //             EmailCliente : ' - ',
    //             FormaPago : pedido.formaPago,
    //             Observaciones : 'Forma servicio: ' + pedido.modo,
    //             Lineas : lineas
    //         }
    //         return pedidoNeo;
    //     })
    //     .then((p) => {
    //         let url = rootGetters['config/urlNeo'];
    //         let data = new FormData();
    //         data.append('token',state.token);
    //         data.append('pedido',JSON.stringify(p));
    //         return axios.post(url+'insertarpedido.php', data)
    //         .then(function(r){
    //             if (r.data.result=="error"){
    //                 Promise.reject("error en Neo");
    //             }
    //             console.log(r);
    //             return r;
    //         })
    //         .catch((error) => {
    //             console.log(error)
    //         })
    //     })
        
    // }

}